// Libraries
import { createElement } from 'react';
// Components
import { CsvFileIcon, FileIcon } from '@atoms/Icons';
// Types
import { IconBaseFiles, IconFileProps } from './IconFile.types';

/**
 * Mapping of content types to corresponding icon components.
 *
 */
const iconBaseFiles: IconBaseFiles = {
  'text/csv': createElement(CsvFileIcon, { boxSize: 6 }),
  'text/xlsx': createElement(FileIcon, { boxSize: 6 }),
};

/**
 * Component for rendering an icon based on the file content type.
 *
 * @component
 * @param {object} props - The component props.
 * @param {string} props.contentType - The content type of the file.
 * @returns {ReactElement} - The JSX element representing the icon for the file.
 */
export const IconFile = ({ contentType }: IconFileProps) =>
  iconBaseFiles[contentType] || createElement(CsvFileIcon, { boxSize: 6 });
